import { BillingCycle } from '~/graphql/types';

const isBillingCycle = (value: any): value is BillingCycle =>
  Object.values(BillingCycle).includes(value);

export default isBillingCycle;
